import {Provider} from '@angular/core';
import {of} from 'rxjs';

import {ClientLoadingService} from '../../../services/auth/client-loading.service';
import {ClientService} from '../../../services/auth/client.service';
import {CompanyService} from '../../../services/enrich/company.service';
import {EnrichConsoleDiagnosticsService} from '../../../services/enrich/enrich-console-diagnostics.service';
import {HubspotService} from '../../../services/enrich/hubspot.service';
import {ReferenceService} from '../../../services/enrich/reference.service';
import {ToastService} from '../../../services/layout/toast.service';

const fixtureClient = {
  id: 'enrich-search-fixture',
  name: 'Search Demo',
  logo: '',
  description: '',
  domain: 'fixture.invalid',
  enabledProducts: ['Shine Enrich'],
};

const enumeratedValues: Record<string, Array<{value: string; count: number}>> = {
  municipality: [{value: 'Oslo', count: 154321}, {value: 'Bergen', count: 58210}],
  organization_type: [{value: 'Aksjeselskap', count: 312456}, {value: 'Enkeltpersonforetak', count: 401234}],
  region: [{value: 'Oslo', count: 184210}, {value: 'Vestland', count: 126543}],
};

export const enrichCompanySearchVisualFixtureProviders: Provider[] = [
  {provide: ClientService, useValue: {client: fixtureClient}},
  {provide: ClientLoadingService, useValue: {ensureClientSelected: () => of(fixtureClient)}},
  {
    provide: CompanyService,
    useValue: {
      searchCompanies: () => of({
        companies: [
          {company_id: '111111111', company_name: 'Nordic Example AS', postal_place: 'OSLO', number_of_employees: 24},
          {company_id: '222222222', company_name: 'Segment Demo AS', postal_place: 'OSLO', number_of_employees: 51},
        ],
        totalCount: 184210,
      }),
      importCompany: () => of({message: 'Company imported successfully'}),
    },
  },
  {
    provide: HubspotService,
    useValue: {
      getSettings: () => of({crmOrgNumberProperty: 'organization_number'}),
      getImportedCompaniesPage: () => of({
        schemaVersion: 'hubspot-imported-companies.v1',
        limit: 100,
        after: null,
        nextAfter: null,
        hasMore: false,
        truncation: null,
        items: [],
      }),
    },
  },
  {
    provide: ReferenceService,
    useValue: {
      getNaceCodes: () => of([
        {nace_code1: '62.010', nace_code1_complete: '62.010 - Computer programming activities', count: 16452},
        {nace_code1: '43.210', nace_code1_complete: '43.210 - Electrical installation', count: 12874},
      ]),
      getEmployeeGroups: () => of([
        {number_of_employees_group: '10 - 19', count: 54321},
        {number_of_employees_group: '20 - 49', count: 32765},
      ]),
      getEnumeratedFieldValues: (fieldName: string) => of(enumeratedValues[fieldName] || []),
    },
  },
  {provide: ToastService, useValue: {showSuccess: () => undefined, showError: () => undefined, showInfo: () => undefined}},
  {provide: EnrichConsoleDiagnosticsService, useValue: {reportError: () => undefined}},
];
